import { LoginComponent } from './login/login.component';
import { LoginFailedComponent } from './login-failed/login-failed.component';
import { SignupComponent } from './signup/signup.component';
import { AuthErrorOverlayComponent } from '../shared';

export const AUTH_ROUTES = [
  { path: 'login', component: LoginComponent },
  { path: 'signup', component: SignupComponent },
  { path: 'login-failed', component: LoginFailedComponent },
  { path: 'error', component: AuthErrorOverlayComponent },
];
